import React, { useState } from 'react';
import { Search } from 'lucide-react';
import './styles.scss';

interface SearchParticipantProps {
  onSearch?: (query: string) => void;
  placeholder?: string;
  className?: string;
}

export function SearchParticipant({ 
  onSearch, 
  placeholder = "Buscar participante...",
  className = "" 
}: SearchParticipantProps) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    onSearch?.(value);
  };

  const handleClear = () => {
    setSearchQuery('');
    onSearch?.('');
  };

  return (
    <div className={`search-participant ${className}`}>
      <div className="search-input-wrapper">
        <Search className="search-icon" size={20} />
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearch}
          placeholder={placeholder}
          className="search-input"
        />
        {searchQuery && (
          <button 
            onClick={handleClear}
            className="clear-button"
            aria-label="Limpar busca"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
